import { memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const ChartSkeleton = memo(function ChartSkeleton() {
  return (
    <div className="w-full h-full flex flex-col gap-2 p-4">
      <div className="flex justify-between items-center">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-4 w-24" />
      </div>
      <div className="flex-1 flex items-end gap-1">
        {Array.from({ length: 20 }, (_, i) => (
          <Skeleton
            key={i}
            className="flex-1"
            style={{ height: `${30 + Math.random() * 60}%` }}
          />
        ))}
      </div>
    </div>
  );
});
